import { render } from "./editclassify.vue?vue&type=template&id=a9fd6774&scoped=true"
import script from "./editclassify.vue?vue&type=script&lang=js"
export * from "./editclassify.vue?vue&type=script&lang=js"

import "./editclassify.vue?vue&type=style&index=0&id=a9fd6774&lang=scss&scoped=true"
import "./editclassify.vue?vue&type=style&index=1&id=a9fd6774&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fd6774"]])

export default __exports__